import {
  NewGameListParams,
  NewGamePageInfo,
} from '@/common-pages/casino/casino.service';
import {http, indusWinHttp} from '@/utils';
import {GoldAreaItem} from '@/pages/home/home.type';

export type Provider = {
  id: number;
  name: string;
  logo: string;
};

export type GameCategory = {
  id: number;
  name: string;
  logo: string;
};

export function getGameCategory(name: 'casino' | 'liveCasino') {
  return http.post<any, GameCategory[]>('app/homeGames/getGameCategory', {
    name,
  });
}

// 获取厂商列表
export function getGameProvider(name: 'casino' | 'liveCasino') {
  return http.post<any, Provider[]>('app/homeGames/getGameProvider', {name});
}

export function postNewGameList(params: NewGameListParams) {
  return http.post<NewGameListParams, NewGamePageInfo>(
    'app/homeGames/getList',
    params,
  );
}

export interface LiveHotGameItem {
  tripartiteUniqueness: string;
  bannerImg: string;
  gameLink: string;
  otherUrl: string;
  provider: string;
  source: string;
  gameId: number;
}

// 首页hot游戏
export function getLiveHotGameList() {
  return indusWinHttp.get<null, LiveHotGameItem[]>(
    'iGaming/liveCasinoHotGameList',
  );
}

// 获取顶部tab
export const getGoldAreaList = (groupCode = 'KING_KONG') => {
  return http.post<
    {
      groupCode: string;
    },
    GoldAreaItem[]
  >('app/moduleTypes/getAllListBySort', {
    groupCode,
  });
};

/** 首页刮刮乐卡片 */
export interface ScratchListItem {
  cover: string;
  price: string;
  name: string;
  cover2: string;
  end_time: number | Date;
  cover_award: number;
  id: number;
  gameUrl?: string;
  freeTicketNum?: number;
}

export interface ScratchFreeData {
  freeTicketNum: number;
  scratchCode: string;
  scratchName: string;
}

export const getScratchFree = () => {
  return indusWinHttp.get<null, ScratchFreeData[]>(
    'iGaming/common/getScratchGameFree',
  );
};

/** 获取刮刮乐入口列表 */
export const getScratchList = () => {
  return indusWinHttp.get<null, ScratchListItem[]>(
    'iGaming/api/scratchoffGameList',
  );
};
